import { useTranslation } from 'react-i18next'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { GlobeIcon } from 'lucide-react'
import PropertyPopoverTrigger from '@/components/common/propertyPopoverOverlay/PropertyPopoverTrigger.tsx'
import i18n from 'i18next'
import PopoverOverlay from '@/components/common/propertyPopoverOverlay/PopoverOverlay.tsx'
import { FLAGS_MAP, Poland, Russia, UK, Ukraine } from '@/assets/icons/CountryFlags.tsx'
import { useUserStore } from '@/store/user.ts'
import { api } from '@/lib/api-client.ts'

type NavLangPopoverProps = {
  label?: string
}
export default function NavLangPopover(props: NavLangPopoverProps) {
  const { label } = props
  const { t } = useTranslation()
  const userId = useUserStore(state => state.user?.id)
  const langProps: PopoverProperty[] = [
    {
      label: t('navigation.languages.pl'),
      value: 'pl',
      icon: <Poland />,
    },
    {
      label: t('navigation.languages.en'),
      value: 'en',
      icon: <UK />,
    },
    {
      label: t('navigation.languages.ua'),
      value: 'ua',
      icon: <Ukraine />,
    },
    {
      label: t('navigation.languages.ru'),
      value: 'ru',
      icon: <Russia />,
    },
  ]
  function toggleLang(val: string) {
    i18n.changeLanguage(val)
    // Persist the choice server-side so notification emails/push localise to it.
    // Online-only, best-effort: localStorage (buildLogLang) stays the client
    // cold-start source, so a failed PATCH never blocks the UI language switch.
    if (userId) {
      void api.patch(`/users/${userId}`, { locale: val }).catch(() => {})
    }
  }

  const getIcon = () => {
    return FLAGS_MAP[i18n.language] || <GlobeIcon className="h-4 w-4" />
  }
  return (
    <PopoverOverlay
      className={`md:w-[calc(var(--sidebar-width)-48px)]`}
      closeOnSelect={true}
      properties={langProps}
      selectedValues={[i18n.language]}
      customTrigger={
        <PropertyPopoverTrigger
          labelClassName={` text-sm w-full flex font-normal   `}
          cl={`hover:bg-accent rounded-md flex h-9 w-full items-center rounded-md text-sm text-accent-foreground
            `}
          variant={`ghost`}
          label={label ? label : i18n.language.toUpperCase()}
          icon={getIcon()}
          debug={true}
        />
      }
      addSelectedValue={toggleLang}
    />
  )
}
